import React, { useEffect, useRef, useState } from 'react'

import { ImageContainer } from '~/components/ImageContainer';
import { ImageContextMenu } from '~/components/ImageContextMenu';
//import { IThreeInstance, ThreeCanvas } from '~/components/ThreeCanvas';
import { IPanoInstance, PanoViewer } from '~/components/PanoViewer';
import { useCanvas } from '~/contexts/CanvasContext';
import { useNotification } from '~/contexts/NotificationContext';
import { ICamera } from '~/domain/ICamera';
import { IImageSettings } from '~/domain/IImageSettings';
import { ResponseError } from '~/domain/ResponseError';
import { useContextMenu } from '~/hooks/useContextMenu';
import { useImageQuery } from '~/hooks/useImage';
//import { useImageSphere, usePan, useZoom } from '~/hooks/useThree';
//import { useImageSphere } from '~/hooks/useThree';
import * as LAYOUT from '~/pages/layout';
import { useAppDispatch } from '~/redux';
import { addImageError } from '~/redux/features/imageErrorsSlice';

import { AnnotateContainer } from './AnnotateContainer';
import { AnnotationToolbar } from './AnnotationToolbar';
import { ImageAnnotation } from './ImageAnnotation';
import { CENTERPANO_PREVIEW_IMAGE_SETTINGS } from './imageSettings';

interface IVehiclePanorama {
  camera: ICamera;
  settings: IImageSettings;
  containerWidth: number;
}

// checks is image has started been rendered
const isCanvasEmpty = (canvas: HTMLCanvasElement) => {
  const blank = document.createElement('canvas');

  blank.width = canvas.width;
  blank.height = canvas.height;

  return canvas.toDataURL() === blank.toDataURL();
}

export const VehiclePanorama: React.FC<IVehiclePanorama> = (props) => {
  const dispatch = useAppDispatch();
  const { settings, containerWidth, camera } = props;
  const { aspectRatio } = settings;
  const ref = useRef() as React.MutableRefObject<IPanoInstance>;
  const innerRef = useRef() as React.MutableRefObject<HTMLCanvasElement>;
  const canvasRef = useRef() as React.MutableRefObject<fabric.Canvas>;
  const notify = useNotification();
  const {
    isFetching,
    isError,
    isInitialLoading,
    data: src,
    refetch,
    error,
  } = useImageQuery({ settings, camera });
  const context = useCanvas();
  const { annotationEnabled, getBlob } = context;
  const [annotationSrc, annotate] = useState<string>();
  const [anchorPosition, contextMenu] = useContextMenu({ isFetching, isError });
  //const [useZoom, setUseZoom] = useState<boolean>(false);
  //console.log('VehiclePanorama props: ', props);
  //console.log('VehiclePanorama useZoom: ', useZoom);

  // useImageSphere({
  //   ref,
  //   src,
  // });

  // usePan({
  //   ref,
  //   context,
  // });

  // useZoom({
  //   ref,
  //   context,
  // });

  useEffect(() => {
    let canceled = false;
    let url: string;
    const extractBlob = () => {
      // this time out  ensures the image is fully rendered
      
      setTimeout(async () => {
        const blob = await getBlob(innerRef);
        
        if (!canceled && blob) {
          url = URL.createObjectURL(blob);
          annotate(url);
        }
      }, 500);
    };
    const requestImage = () => {
      requestAnimationFrame(() => {
        if (!canceled) {
          if (isCanvasEmpty(innerRef.current)) {
            requestImage();
          } else {
            extractBlob();
          }
        }
      });
    };
    if (annotationEnabled) {
      if (isCanvasEmpty(innerRef.current)) {
        requestImage();
      } else {
        extractBlob();
      }
      //setUseZoom(true)
    } else {
      annotate(undefined);
      //setUseZoom(false);
    }
    return () => {
      canceled = true;
      if (url) {
        URL.revokeObjectURL(url);
      }
    }
  }, [annotationEnabled, getBlob]);

  useEffect(() => {
    if (isError) {
      if (error) {
        const respError = error as ResponseError;
        dispatch(addImageError(respError.message));
      }
      notify({ type: 'warning', message: 'We couldn’t load this image. Please refresh or try again later' });
    }
  }, [isError, error, notify, dispatch]);

  return (
    <>
      <AnnotateContainer
        isAnnotating={annotationEnabled}
        containerWidth={containerWidth}
        onContextMenu={contextMenu.onContextMenu}
      >
        <ImageContainer
          aspectRatio={aspectRatio}
          isFetching={isFetching}
          isError={isError}
          isInitialLoading={isInitialLoading}
          refetch={refetch}
          zoom = {false}
        >
          {/* <ThreeCanvas
            ref={ref}
            innerRef={innerRef}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: annotationSrc ? 'none' : 'block',
            }}
          /> */}

          <PanoViewer
            ref={ref}
            innerRef={innerRef}
            url={src}
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgound:'#ffffff',
              display: annotationSrc ? 'none' : 'block',
            }}
          />

          {!!annotationSrc && (
            <ImageAnnotation
              ref={canvasRef}
              src={annotationSrc}
              aspectRatio={aspectRatio}
              sx={LAYOUT.IMAGE}
              zoomed={false}
            />
          )}
        </ImageContainer>
        {annotationEnabled && <AnnotationToolbar canvasRef={canvasRef} disabled={isError || isFetching || !annotationSrc} />}
      </AnnotateContainer>
      <ImageContextMenu
        anchorPosition={anchorPosition}
        context={contextMenu}
        camera={camera}
        images={[
          { label: 'HD', settings: settings },
          { label: '4K', settings: CENTERPANO_PREVIEW_IMAGE_SETTINGS },
        ]}
      />
    </>
  );
}
